import React from 'react';
import ReactDOM from 'react-dom/client';
import { CssBaseline, ThemeProvider as MuiThemeProvider } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { lightTheme, darkTheme } from './theme';
import { ThemeProvider, useThemeContext } from './features/theme/context/ThemeContext';
import './index.css';

const AppWithTheme: React.FC = () => {
  const { isDarkMode } = useThemeContext();
  const theme = isDarkMode ? darkTheme : lightTheme;

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </MuiThemeProvider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <ThemeProvider>
    <AppWithTheme />
  </ThemeProvider>
);
